import api from './api';
import { 
  ApiResponse, 
  MiniQuizStartResponse,
  MiniQuizSubmitResponse,
  MiniQuizCurrentQuestion,
  MiniQuizHistory,
  MiniQuizSessionDetails,
  MiniQuizRemainingAttempts
} from '../types';

export const miniQuizApi = {
  
  // Bắt đầu mini quiz mới
  startQuiz: async (): Promise<ApiResponse<MiniQuizStartResponse>> => {
    const response = await api.post('/mini-quiz/start');
    return response.data;
  },

  // Gửi câu trả lời
  submitAnswer: async (
    sessionId: string, 
    questionId: string, 
    answer: boolean
  ): Promise<ApiResponse<MiniQuizSubmitResponse>> => {
    const response = await api.post('/mini-quiz/submit', {
      sessionId,
      questionId,
      answer
    });
    return response.data;
  },

  // Lấy câu hỏi hiện tại
  getCurrentQuestion: async (sessionId: string): Promise<ApiResponse<MiniQuizCurrentQuestion>> => {
    const response = await api.get(`/mini-quiz/current/${sessionId}`);
    return response.data;
  },

  // Lấy lịch sử mini quiz
  getHistory: async (): Promise<ApiResponse<MiniQuizHistory>> => {
    const response = await api.get('/mini-quiz/history');
    return response.data;
  },

  // Lấy chi tiết phiên quiz
  getSessionDetails: async (sessionId: string): Promise<ApiResponse<MiniQuizSessionDetails>> => {
    const response = await api.get(`/mini-quiz/session/${sessionId}`);
    return response.data;
  },

  // Lấy số lượt còn lại
  getRemainingAttempts: async (): Promise<ApiResponse<MiniQuizRemainingAttempts>> => {
    const response = await api.get('/mini-quiz/remaining-attempts');
    return response.data;
  }
};
